export class Marca {
    idMarca: number;
    clave: string;
    descripcion: string;
    seleccionada: boolean;
}



// WEBPACK FOOTER //
// C:/Users/stivens/Lab/sonever/repos/taller-web/src/app/core/model/classes/marca.ts